const menuElements = [
  {
    titulo_seccion: 'Destacados',
    contenido_seccion: [
      {
        id: 'd-1',
        img: 'destacados-1',
        titulo: 'Philadelphia Roll',
        descripcion: 'Salmón, palta y cream cheese',
        precio: 290
      },
      {
        id: 'd-2',
        img: 'destacados-2',
        titulo: 'Crazy Roll',
        descripcion: 'Langostinos, palta, cream cheese y salmón por fuera',
        precio: 290
      },
      {
        id: 'd-3',
        img: 'destacados-3',
        titulo: 'Buenos Aires Roll',
        descripcion: 'Salmón, langostinos, palta, cream cheese y salsa de sésamo',
        precio: 310
      },
      {
        id: 'd-4',
        img: 'destacados-4',
        titulo: 'Niguiri de Langostino',
        descripcion: 'Langostino y arroz',
        precio: 295
      },
      {
        id: 'd-5',
        img: 'destacados-5',
        titulo: 'Salmón Stick Roll',
        descripcion: 'Salmón furai, cream cheese, salsa de jengibre y miel',
        precio: 315
      },
      {
        id: 'd-6',
        img: 'destacados-6',
        titulo: 'Niguiri de Salmón',
        descripcion: 'Salmón furai y arroz',
        precio: 290
      },
      {
        id: 'd-7',
        img: 'destacados-7',
        titulo: 'Tex-Mex Roll',
        descripcion: 'Salmón fresco, guacamole y salsa de cilantro',
        precio: 275
      }
    ]
  },
  {
    titulo_seccion: 'Rolls',
    contenido_seccion: [
      {
        id: 'pacific-roll',
        titulo: 'Pacific',
        descripcion: 'Calamar rebozado, queso y verdeo con salsa picante',
        precio: 245
      },
      {
        id: 'mistic-roll',
        titulo: 'Mistic ',
        descripcion: 'Salmon crujiente, envuelto en lamina de plata y salsa de sesamo dulce',
        precio: 290
      },
      {
        id: 'smoked-roll',
        titulo: 'Smoked',
        descripcion: 'Salmón crujiente y queso, envuelto en salmón ahumado con salsa picante',
        precio: 260
      },
      {
        id: 'pic-sh',
        titulo: 'Pic sh',
        descripcion: 'Palta, palmito y queso envuelto en tamago y salmon. Batatas fritas y salsa de maracuya',
        precio: 300
      },
      {
        id: 'gratin-roll',
        titulo: 'Gratin roll',
        descripcion: 'Langostinos apanados y queso de salmon con sardo gratinado',
        precio: 265
      },
      {
        id: 'pacific-roll2',
        titulo: 'Pacific',
        descripcion: 'Calamar rebozado, queso y verdeo con salsa picante',
        precio: 245
      },
      {
        id: 'mistic-roll2',
        titulo: 'Mistic roll',
        descripcion: 'Salmon crujiente, envuelto en lamina de plata y salsa de sesamo dulce',
        precio: 290
      },
      {
        id: 'smoked-roll2',
        titulo: 'Smoked-roll',
        descripcion: 'Salmón crujiente y queso, envuelto en salmón ahumado con salsa picante',
        precio: 260
      },
      {
        id: 'gratin-roll2',
        titulo: 'Gratin roll',
        descripcion: 'Langostinos apanados y queso de salmon con sardo gratinado',
        precio: 265
      }
    ]
  },
  {
    titulo_seccion: 'Tei woks',
    contenido_seccion: [
      {
        id: 'wok-1',
        titulo: 'Blue box',
        descripcion: 'Wok de pollo con vegetales salteados sobre base de arroz gohan con salsa de curry',
        precio: 265
      },
      {
        id: 'wok-2',
        titulo: 'Wok de lomo',
        descripcion: 'Sashimis de lomo marinados en jengibre con cebolla morada y gajos de tomate sobre una base de arroz gohan y salsa de ostras',
        precio: 315
      },
      {
        id: 'wok-3',
        titulo: 'Wok de salmon',
        descripcion: 'Cubos de salmón sobre una base de arroz gohan con verdeo y salsa de soja',
        precio: 260
      },
      {
        id: 'wok-4',
        titulo: 'Veggie wok',
        descripcion: 'Vegetales salteados sobre una base de arroz gohan',
        precio: 300
      }
    ]
  },
  {
    titulo_seccion: 'Bebidas y postres',
    contenido_seccion: [
      {
        id: 'bebida-1',
        titulo: 'Gaseosas 350CC',
        descripcion: 'Línea Pepsi',
        precio: 62
      },
      {
        id: 'bebida-2',
        titulo: 'Aguas',
        descripcion: 'Con o sin gas',
        precio: 62
      },
      {
        id: 'bebida-3',
        titulo: 'Limonadas',
        descripcion: 'Limón agua y azúcar',
        precio: 70
      },
      {
        id: 'bebida-4',
        titulo: 'Limonada detox',
        descripcion: 'Con menta y jengibre',
        precio: 70
      },
      {
        id: 'bebida-5',
        titulo: 'Fernet Branca',
        descripcion: 'Con coca',
        precio: 180
      },
      {
        id: 'bebida-6',
        titulo: 'Branca menta',
        descripcion: 'Con sprite',
        precio: 180
      },
      {
        id: 'bebida-7',
        titulo: 'Gin tonic',
        descripcion: 'Gin y agua tónica',
        precio: 190
      },
    ]
  }
];

export default menuElements;